var map = {
	"./action_img.png": 112,
	"./background.png": 335,
	"./banner_shap.png": 336,
	"./cloud-computing.png": 337,
	"./cloud_01.png": 113,
	"./cloud_02.png": 114,
	"./cloud_03.png": 115,
	"./cloud_04.png": 116,
	"./cloud_05.png": 117,
	"./cloud_06.png": 118,
	"./crm_img1.jpg": 338,
	"./crm_img2.jpg": 339,
	"./crm_img3.jpg": 340,
	"./erp_dashboard.jpg": 119,
	"./erp_icon1.png": 341,
	"./erp_icon2.png": 342,
	"./erp_icon3.png": 343,
	"./erp_icon4.png": 344,
	"./erp_icon5.png": 345,
	"./erp_icon6.png": 346,
	"./growth.png": 347,
	"./img/01.png": 120,
	"./img/02.png": 121,
	"./img/03.png": 122,
	"./img/04.png": 123,
	"./img/05.png": 124,
	"./img/06.png": 125,
	"./img/07.png": 126,
	"./img/08.png": 127,
	"./img/09.png": 128,
	"./img/10.png": 129,
	"./img/11.png": 130,
	"./img/12.png": 131,
	"./img/13.png": 132,
	"./img/14.png": 133,
	"./img/15.png": 134,
	"./img/16.png": 135,
	"./img/17.png": 136,
	"./img/18.png": 137,
	"./img/19.png": 138,
	"./img/20.png": 139,
	"./quote.png": 348,
	"./rocket.png": 140,
	"./settings1.png": 349,
	"./shape.png": 350,
	"./testimonial_img.jpg": 351,
	"./testimonial_img2.jpg": 352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;